import { render } from "./adminFooter.vue?vue&type=template&id=64729dfa&scoped=true"
import script from "./adminFooter.vue?vue&type=script&lang=js"
export * from "./adminFooter.vue?vue&type=script&lang=js"

import "./adminFooter.vue?vue&type=style&index=0&id=64729dfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64729dfa"]])

export default __exports__